module.exports = __webpack_public_path__ + "static/img/wentifankui.a4516d2a.png";